
import { defineAsyncComponent, defineComponent, PropType } from 'vue';

import { ContentBase } from '@/models/content_base';

import ContentCustomizingPurchaseCountDeclare from './ContentCustomizingPurchaseCountDeclare.vue';
import ContentCustomizingPurchaseCountInput from './ContentCustomizingPurchaseCountInput.vue';
import ContentCustomizingUploadedText from './ContentCustomizingUploadedText.vue';

export default defineComponent({
  name: 'ContentCustomizing',
  components: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Content: defineAsyncComponent((): any => import('./Content.vue')),
    ContentCustomizingPurchaseCountInput,
    ContentCustomizingPurchaseCountDeclare,
    ContentCustomizingUploadedText,
  },
  props: {

    /**
     * キー名
     */
    keyName: {
      type: String,
      required: true,
    },

    /**
     * コンテンツ
     */
    contents: {
      type: Array as PropType<ContentBase[]>,
      required: true,
    },
  },
});
